import axiosApiInstance from "../../app/axios";
import { API_BASE_URL } from "../../app/utils";

export const getMyProfile = () =>
  axiosApiInstance.get(`${API_BASE_URL}/user-store/v1/users/me/profile`);
